import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DomainService } from '../domain.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryServiceNativeService {
  private _apiUrl: string = '';

  constructor(private readonly http: HttpClient,
    private _domainService: DomainService,
  ) {
    this._domainService.apiUrl$.subscribe((apiUrl: string) => {
      this._apiUrl = apiUrl;
    });
  }

  getOrderManagement(params: { id: number }): Observable<any> {
    return this.http.get<any>(`${this._apiUrl}delivery/neworder/${params.id}?format=json`);
  }

  getNewShipmentDetails(params: { id: number }): Observable<any> {
    return this.http.get<any>(`${this._apiUrl}delivery/newshipment/${params.id}?format=json`);
  }
};

   



